// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"28":"c80d4a8c","53":"99887611","208":"3bf96592","226":"918cb81c","435":"d2fd7b37","454":"69835425","458":"a127a4bd","666":"94aa46be","818":"69835425","852":"3047f248","893":"1b826c16","911":"2b33b26e","966":"562c2908"}[chunkId] + ".chunk.css";
};